let hasPendingUploads = false;
let isLeavingConfirmed = false;

export function setHasPendingUploads(value: boolean): void {
    hasPendingUploads = value;
}

export function hasConfirmedLeaving(): boolean {
    return isLeavingConfirmed;
}

export function confirmLeavingPendingUploads(): boolean {
    if (!hasPendingUploads) return true;
    isLeavingConfirmed = window.confirm('Er worden nog bestanden geüpload. Als je doorgaat, stopt het uploaden. Doorgaan?');
    return isLeavingConfirmed;
}
